export const columnData = [
  {
    title: '日期',
    sortable: true,
    width: 180,
    always: true,
    fixed: 'left',
    index: '1',
    key: 'statDate'
  },
  {
    title: '消耗',
    sortable: true,
    width: 100,
    index: '2',
    key: 'cost'
  },
  {
    title: '用户数',
    sortable: true,
    width: 100,
    notFixed:true,
    index: '3',
    flag: 1,
    key: 'userCountNew'
  },
  {
    title: '用户数',
    sortable: true,
    notFixed:true,
    width: 100,
    index: '4',
    flag: 2,
    key: 'userCountAll'
  },
  {
    title: '新用户成本',
    sortable: true,
    width: 140,
    flag: 1,
    index: '5',
    key: 'activationCostNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostNew
            ? Number(params.row.activationCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '染色用户成本',
    sortable: true,
    width: 140,
    index: '6',
    flag: 2,
    key: 'activationCostAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostAll
            ? Number(params.row.activationCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费率',
    sortable: true,
    width: 120,
    flag: 1,
    index: '52',
    needCalc: true,
    key: 'firstDayPayPrecentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayPrecentNew
            ? (Number(params.row.firstDayPayPrecentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费率',
    sortable: true,
    width: 120,
    flag: 2,
    needCalc: true,
    index: '53',
    key: 'firstDayPayPrecentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayPrecentAll
            ? (Number(params.row.firstDayPayPrecentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日arppu',
    sortable: true,
    width: 120,
    index: '58',
    flag: 1,
    key: 'firstDayArppuNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuNew|| 0}
        </div>
      )
    }
  },
  {
    title: '首日arppu',
    sortable: true,
    flag: 2,
    width: 120,
    index: '59',
    key: 'firstDayArppuAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuAll||0}
        </div>
      )
    }
  },
  {
    title: '新增充值人数',
    sortable: true,
    notFixed:true,
    width: 130,
    index: '46',
    flag: 1,
    key: 'paySuccessUserCountNew'
  },
  {
    title: '新增充值人数',
    sortable: true,
    notFixed:true,
    width: 130,
    flag: 2,
    index: '47',
    key: 'paySuccessUserCountAll'
  },
  {
    title: '首日付费成本',
    sortable: true,
    width: 130,
    index: '50',
    key: 'firstDayPayCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostNew
            ? Number(params.row.firstDayPayCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费成本',
    sortable: true,
    width: 120,
    flag: 2,
    index: '51',
    key: 'firstDayPayCostAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostAll
            ? Number(params.row.firstDayPayCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    sortable: true,
    width: 100,
    index: '28',
    flag: 1,
    needCalc: true,
    key: 'firstROINew',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROINew
            ? (Number(params.row.firstROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    flag: 2,
    sortable: true,
    width: 100,
    needCalc: true,
    index: '29',
    key: 'firstROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROIAll
            ? (Number(params.row.firstROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    sortable: true,
    width: 100,
    index: '30',
    flag: 1,
    needCalc: true,
    key: 'thirdROINew',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROINew
            ? (Number(params.row.thirdROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    sortable: true,
    flag: 2,
    width: 100,
    index: '31',
    needCalc: true,
    key: 'thirdROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROIAll
            ? (Number(params.row.thirdROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    sortable: true,
    width: 100,
    flag: 1,
    index: '32',
    key: 'eighthROINew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROINew
            ? (Number(params.row.eighthROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    sortable: true,
    width: 100,
    flag: 2,
    index: '33',
    key: 'eighthROIAll',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROIAll
            ? (Number(params.row.eighthROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日ROI',
    sortable: true,
    width: 110,
    index: '34',
    key: 'fifthROINew',
    flag: 1,
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROINew
            ? (Number(params.row.fifthROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日ROI',
    sortable: true,
    width: 110,
    index: '35',
    needCalc: true,
    key: 'fifthROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROIAll
            ? (Number(params.row.fifthROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    sortable: true,
    width: 110,
    flag: 1,
    index: '36',
    needCalc: true,
    key: 'thirtyROINew',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyROINew
            ? (Number(params.row.thirtyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    sortable: true,
    needCalc: true,
    width: 110,
    flag: 2,
    index: '37',
    key: 'thirtyROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyROIAll
            ? (Number(params.row.thirtyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日ROI',
    sortable: true,
    width: 110,
    index: '38',
    flag: 1,
    key: 'sixtyROINew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyROINew
            ? (Number(params.row.sixtyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日ROI',
    sortable: true,
    width: 110,
    index: '39',
    flag: 2,
    key: 'sixtyROIAll',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyROIAll
            ? (Number(params.row.sixtyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '90日ROI',
    sortable: true,
    width: 110,
    flag: 1,
    index: '40',
    key: 'ninetyROINew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.ninetyROINew
            ? (Number(params.row.ninetyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '90日ROI',
    sortable: true,
    width: 110,
    index: '41',
    needCalc: true,
    flag: 2,
    key: 'ninetyROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.ninetyROIAll
            ? (Number(params.row.ninetyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '120日ROI',
    sortable: true,
    width: 130,
    flag: 1,
    index: '42',
    needCalc: true,
    key: 'oneHundredAndTwentyROINew',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndTwentyROINew
            ? (Number(params.row.oneHundredAndTwentyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '120日ROI',
    sortable: true,
    width: 130,
    flag: 2,
    index: '43',
    needCalc: true,
    key: 'oneHundredAndTwentyROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndTwentyROIAll
            ? (Number(params.row.oneHundredAndTwentyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '150日ROI',
    sortable: true,
    width: 130,
    flag: 1,
    index: '44',
    needCalc: true,
    key: 'oneHundredAndFiftyROINew',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndFiftyROINew
            ? (Number(params.row.oneHundredAndFiftyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '150日ROI',
    sortable: true,
    width: 130,
    flag: 2,
    index: '45',
    needCalc: true,
    key: 'oneHundredAndFiftyROIAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndFiftyROIAll
            ? (Number(params.row.oneHundredAndFiftyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '10',
    key: 'firstRechargeNew'
  },
  {
    title: '首日充值金额',
    sortable: true,
    width: 140,
    flag: 2,
    index: '11',
    key: 'firstRechargeAll'
  },
  {
    title: '3日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '12',
    key: 'thirdRechargeNew'
  },
  {
    title: '3日充值金额',
    flag: 2,
    sortable: true,
    width: 140,
    index: '13',
    key: 'thirdRechargeAll'
  },
  {
    title: '8日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '14',
    key: 'eighthRechargeNew'
  },
  {
    title: '8日充值金额',
    sortable: true,
    flag: 2,
    width: 140,
    index: '15',
    key: 'eighthRechargeAll'
  },
  {
    title: '15日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '16',
    key: 'fifthRechargeNew'
  },
  {
    title: '15日充值金额',
    sortable: true,
    flag: 2,
    width: 140,
    index: '17',
    key: 'fifthRechargeAll'
  },
  {
    title: '30日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '18',
    key: 'thirtyRechargeNew'
  },
  {
    title: '30日充值金额',
    sortable: true,
    width: 140,
    flag: 2,
    index: '19',
    key: 'thirtyRechargeAll'
  },
  {
    title: '60日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '20',
    key: 'sixtyRechargeNew'
  },
  {
    title: '60日充值金额',
    sortable: true,
    flag: 2,
    width: 140,
    index: '21',
    key: 'sixtyRechargeAll'
  },
  {
    title: '90日充值金额',
    sortable: true,
    width: 140,
    flag: 1,
    index: '22',
    key: 'ninetyRechargeNew'
  },
  {
    title: '90日充值金额',
    sortable: true,
    width: 140,
    flag: 2,
    index: '23',
    key: 'ninetyRechargeAll'
  },
  {
    title: '120日充值金额',
    sortable: true,
    flag: 1,
    width: 160,
    index: '24',
    key: 'oneHundredAndTwentyRechargeNew'
  },
  {
    title: '120日充值金额',
    sortable: true,
    width: 160,
    flag: 2,
    index: '25',
    key: 'oneHundredAndTwentyRechargeAll'
  },
  {
    title: '150日充值金额',
    sortable: true,
    width: 160,
    index: '26',
    flag: 1,
    key: 'oneHundredAndFiftyRechargeNew'
  },
  {
    title: '150日充值金额',
    sortable: true,
    flag: 2,
    width: 160,
    index: '27',
    key: 'oneHundredAndFiftyRechargeAll'
  },
  {
    title: '首日付费次数',
    sortable: true,
    width: 160,
    index: '48',
    flag: 1,
    key: 'paySuccessOrderCountNew'
  },
  {
    title: '首日付费次数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '49',
    key: 'paySuccessOrderCountAll'
  },
  {
    title: '首日人均付费次数',
    sortable: true,
    width: 160,
    index: '56',
    flag: 1,
    key: 'firstDayAveragePayFrequencyNew'
  },
  {
    title: '首日人均付费次数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '57',
    key: 'firstDayAveragePayFrequencyAll'
  },
  {
    title: '累计付费率',
    sortable: true,
    width: 160,
    needCalc: true,
    index: '54',
    flag: 1,
    key: 'payPrecentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.payPrecentNew
            ? (Number(params.row.payPrecentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '累计付费率',
    sortable: true,
    width: 160,
    needCalc: true,
    flag: 2,
    index: '55',
    key: 'payPrecentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.payPrecentAll
            ? (Number(params.row.payPrecentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '累计充值金额',
    sortable: true,
    width: 160,
    flag: 1,
    index: '7',
    key: 'rechargeNew'
  },
  {
    title: '累计充值金额',
    sortable: true,
    width: 160,
    index: '8',
    flag: 2,
    key: 'rechargeAll'
  },
  {
    title: '充值流水',
    sortable: true,
    width: 160,
    index: '9',
    key: 'totalRecharge'
  },

  {
    title: '3日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '78',
    key: 'threeTimesGrowthNew'
  },
  {
    title: '3日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '79',
    key: 'threeTimesGrowthAll'
  },
  {
    title: '8日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '80',
    key: 'eighthTimesGrowthNew'
  },
  {
    title: '8日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '81',
    key: 'eighthTimesGrowthAll'
  },
  {
    title: '15日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '82',
    key: 'fifthTimesGrowthNew'
  },
  {
    title: '15日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '83',
    key: 'fifthTimesGrowthAll'
  },
  {
    title: '30日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '84',
    key: 'thirtyTimesGrowthNew'
  },
  {
    title: '30日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '85',
    key: 'thirtyTimesGrowthAll'
  },
  {
    title: '60日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '86',
    key: 'sixtyTimesGrowthNew'
  },
  {
    title: '60日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '87',
    key: 'sixtyTimesGrowthAll'
  },
  {
    title: '90日系数',
    sortable: true,
    width: 160,
    flag: 1,
    index: '88',
    key: 'ninetyTimesGrowthNew'
  },
  {
    title: '90日系数',
    sortable: true,
    width: 160,
    flag: 2,
    index: '89',
    key: 'ninetyTimesGrowthAll'
  },
  {
    title: '120日系数',
    sortable: true,
    width: 170,
    flag: 1,
    index: '90',
    key: 'oneHundredAndTwentyTimesGrowthNew'
  },
  {
    title: '120日系数',
    sortable: true,
    width: 170,
    flag: 2,
    index: '91',
    key: 'oneHundredAndTwentyTimesGrowthAll'
  },
  {
    title: '150日系数',
    sortable: true,
    width: 170,
    flag: 1,
    index: '92',
    key: 'oneHundredAndFiftyTimesGrowthNew'
  },
  {
    title: '150日系数',
    sortable: true,
    width: 170,
    flag: 2,
    index: '93',
    key: 'oneHundredAndFiftyTimesGrowthAll'
  },
  
  {
    title: '次日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    needCalc: true,
    index: '60',
    key: 'twoDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.twoDaysRemainPercentNew
            ? (Number(params.row.twoDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '次日留存率',
    sortable: true,
    needCalc: true,
    width: 140,
    index: '61',
    flag: 2,
    key: 'twoDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.twoDaysRemainPercentAll
            ? (Number(params.row.twoDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    index: '62',
    needCalc: true,
    key: 'threeDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.threeDaysRemainPercentNew
            ? (Number(params.row.threeDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日留存率',
    sortable: true,
    width: 140,
    needCalc: true,
    index: '63',
    flag: 2,
    key: 'threeDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.threeDaysRemainPercentAll
            ? (Number(params.row.threeDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日留存率',
    sortable: true,
    flag: 1,
    needCalc: true,
    width: 140,
    index: '64',
    key: 'eighthDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthDaysRemainPercentNew
            ? (Number(params.row.eighthDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日留存率',
    sortable: true,
    width: 140,
    index: '65',
    needCalc: true,
    flag: 2,
    key: 'eighthDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthDaysRemainPercentAll
            ? (Number(params.row.eighthDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    needCalc: true,
    index: '66',
    key: 'fifthDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthDaysRemainPercentNew
            ? (Number(params.row.fifthDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日留存率',
    sortable: true,
    width: 140,
    index: '67',
    flag: 2,
    needCalc: true,
    key: 'fifthDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthDaysRemainPercentAll
            ? (Number(params.row.fifthDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    index: '68',
    needCalc: true,
    key: 'thirtyDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyDaysRemainPercentNew
            ? (Number(params.row.thirtyDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日留存率',
    sortable: true,
    width: 140,
    needCalc: true,
    flag: 2,
    index: '69',
    key: 'thirtyDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyDaysRemainPercentAll
            ? (Number(params.row.thirtyDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    index: '70',
    key: 'sixtyDaysRemainPercentNew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyDaysRemainPercentNew
            ? (Number(params.row.sixtyDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日留存率',
    sortable: true,
    width: 140,
    index: '71',
    needCalc: true,
    flag: 2,
    key: 'sixtyDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyDaysRemainPercentAll
            ? (Number(params.row.sixtyDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '90日留存率',
    sortable: true,
    width: 140,
    flag: 1,
    needCalc: true,
    index: '72',
    key: 'ninetyDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.ninetyDaysRemainPercentNew
            ? (Number(params.row.ninetyDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '90日留存率',
    sortable: true,
    width: 140,
    index: '73',
    flag: 2,
    needCalc: true,
    key: 'ninetyDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.ninetyDaysRemainPercentAll
            ? (Number(params.row.ninetyDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '120日留存率',
    sortable: true,
    width: 150,
    flag: 1,
    index: '74',
    needCalc: true,
    key: 'oneHundredAndTwentyDaysRemainPercentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndTwentyDaysRemainPercentNew
            ? (Number(params.row.oneHundredAndTwentyDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '120日留存率',
    sortable: true,
    width: 150,
    needCalc: true,
    flag: 2,
    index: '75',
    key: 'oneHundredAndTwentyDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndTwentyDaysRemainPercentAll
            ? (Number(params.row.oneHundredAndTwentyDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '150日留存率',
    sortable: true,
    width: 150,
    flag: 1,
    index: '76',
    key: 'oneHundredAndFiftyDaysRemainPercentNew',
    needCalc: true,
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndFiftyDaysRemainPercentNew
            ? (Number(params.row.oneHundredAndFiftyDaysRemainPercentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '150日留存率',
    sortable: true,
    width: 150,
    flag: 2,
    needCalc: true,
    index: '77',
    key: 'oneHundredAndFiftyDaysRemainPercentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.oneHundredAndFiftyDaysRemainPercentAll
            ? (Number(params.row.oneHundredAndFiftyDaysRemainPercentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  }
]
